/*
Sohel 10/27/2022 2701375033 Integrated Copy Functionality API.
Sohel 10/29/2022 2701375033 Added report code validation.
Prakash 10/29/2022 2701375033 Added New UX Changes for Buttons and Fields.
akhila 11/08/2022 2701375033 Added title field and validation.
Saikrishna 11/08/2022 2701375033 Fixed copy popup bugs after report code changes.
Lalitha 12/23/2022 2701375033 Added reusable Validation in code
sai krisha 30/12/2022 2701375033 add code description values
Suresh Peddavoora  02/13/2023 2701375033 Fixed Textfields Variant
Rohini  03/02/2023 2701375033 worked on the text fields enhancements.
sohel 03/06/2023 2701375033 Added validation message for existing value
Ravi 05/15/2023 2701375033 fixed accept only upper Case in Report Code
Akhila 06/07/2023 2701375033 Added code and description
//Ravi 07/22/2023 2701375033 Added limit char Validation in code and Description
*/
import React, {useContext, useEffect, useRef} from 'react';
import {Formik} from 'formik';
import {Button, FormHelperText, Grid, TextField} from '@material-ui/core';
import ErrorBoundaryForComponents from '../../../../util/ErrorBoundaryForComponents';
import * as Yup from 'yup';
import {ThemeContext} from '../../../../themes/ThemeProvider';
import {useDispatch, useSelector} from 'react-redux';
import {
  postCopyReport,
  getAllReportCodeData,
} from '../../../../redux/reducers/ReportMaster/index';
import PageLoader from './../../../../components/PageLoader/index';
import BreadCrums from '../../../../util/BreadCrum';
import {currsorCodeIssue} from '../../../../components/UpperCaseCode';

const CopyReport = ({oldReportCode, oldReportId, codeAndDescription}) => {
  const {reusableInputStyles} = useContext(ThemeContext);
  const {iscopyLoading, reportCodeData} = useSelector(({reportMaster}) => reportMaster);

  const classes = reusableInputStyles();
  const dispatch = useDispatch();
  const codeRef = useRef();
  const initialValues = {
    reportcode: '',
    title: '',
    description: '',
  };

  const checkReportCodeExist = (value) => {
    if (reportCodeData && reportCodeData?.length > 0 && value) {
      const ar = [];
      reportCodeData?.filter((i) => {
        if (
          i?.reportCode?.toUpperCase()?.trim() === value?.toUpperCase()?.trim() &&
          i?.isActive === 'Y'
        ) {
          ar.push(i);
        }
      });
      return ar.length > 0;
    } else {
      return false;
    }
  };
  const checkReportCodeAlreadyExist = (value) => {
    if (reportCodeData && reportCodeData?.length > 0 && value) {
      const ar = [];
      reportCodeData?.filter((i) => {
        if (
          i?.reportCode?.toUpperCase()?.trim() === value?.toUpperCase()?.trim() &&
          i?.isActive === 'N'
        ) {
          ar.push(i);
        }
      });
      return ar.length > 0;
    } else {
      return false;
    }
  };

  const schema = Yup.object().shape({
    reportcode: Yup.string()
      .required('Report Name is required')
      .test('reportCode', 'Report Name already in use', (value) => !checkReportCodeExist(value))
      .test(
        'reportCode',
        'Report Name has already been used in the past',
        (value) => !checkReportCodeAlreadyExist(value),
      ),
    // title: Yup.string().required("Report title is required")
    //   .test("reportTitle", "Report Title already exist", (value) => !checkReportTitleExist(value)),
    description: Yup.string()
      .required('Report Description is required')
  });

  const handleSubmit = (values) => {
    if (values) {
      const data = {
        oldReportCode: oldReportCode,
        reportCode: values?.reportcode ? values?.reportcode : '',
        title: values?.title ? values?.title : '',
        reportDescription: values?.description ? values?.description : '',
        oldReportId: oldReportId ? oldReportId : 0,
      };
      dispatch(postCopyReport(data));
    }
  };

  useEffect(() => {
    dispatch(getAllReportCodeData('REPORT'));
  }, []);
  return (
    <>
      <div className={classes.addRule}>
        <div className={classes.dialoguecardStyles}>
          <Formik
            onSubmit={(values) => handleSubmit(values)}
            initialValues={initialValues}
            validationSchema={schema}
            enableReinitialize
            validateOnChange
          >
            {(props) => {
              const {
                values,
                handleSubmit,
                handleReset,
                handleChange,
                setFieldValue,
                touched,
                errors,
                resetForm,
                handleBlur,
              } = props;
              return (
                <div>
                  <BreadCrums
                    name={'Name'}
                    code={codeAndDescription?.reportCode}
                    description={'Description'}
                    descriptionValue={codeAndDescription?.reportDescription}
                  />
                  <form autoComplete="off" noValidate onSubmit={handleSubmit} onReset={handleReset}>
                    <div className="global-field-textfields new-standard-textfields">
                      <ErrorBoundaryForComponents>
                        <Grid container spacing={2}>
                          <Grid item xs={3} className="form-group">
                            <TextField
                              // className={` ${classes.labelName} ${classes.inputLabel}`}
                              placeholder="Enter Report Name"
                              margin="dense"
                              name="reportcode"
                              variant="outlined"
                              value={values?.reportcode}
                              label="Report Name"
                              // InputLabelProps={{
                              //   shrink: true,
                              // }}
                              inputProps={{maxLength: 25}}
                              required
                              inputRef={codeRef}
                              onBlur={handleBlur}
                              // onChange={handleChange}
                              onChange={(e) => {
                                handleChange(e);
                                const value = currsorCodeIssue(codeRef);
                                setFieldValue('reportcode', value);
                              }}
                              touched={touched.reportcode}
                              error={Boolean(errors.reportcode && touched.reportcode)}
                              fullWidth
                            />
                            <FormHelperText style={{color: 'red'}} variant="outlined">
                              {touched.reportcode && errors.reportcode}
                            </FormHelperText>
                          </Grid>
                          <Grid item xs={9} className="form-group">
                            <TextField
                              // className={` ${classes.labelName} ${classes.inputLabel}`}
                              placeholder="Enter Report Description"
                              margin="dense"
                              name="description"
                              value={values.description}
                              variant="outlined"
                              label="Report Description"
                              // InputLabelProps={{
                              //   shrink: true,
                              // }}
                              inputProps={{maxLength: 100}}
                              onBlur={handleBlur}
                              onChange={handleChange}
                              touched={touched.description}
                              required
                              error={Boolean(errors.description && touched.description)}
                              fullWidth
                            />
                            <FormHelperText variant="outlined">
                              {touched.description && errors.description}
                            </FormHelperText>
                          </Grid>
                        </Grid>
                      </ErrorBoundaryForComponents>
                    </div>
                    <div className="button-spacing-mb new-standard-textfields">
                      <Button
                        variant="outlined"
                        onClick={() => {
                          resetForm(initialValues);
                        }}
                        className={`reset-btn mr-1 ${classes.buttonRoot}`}
                      >
                        Reset
                      </Button>
                      <Button
                        variant="outlined"
                        type="submit"
                        className={`search-btn ml-1 ${classes.buttonRoot}`}
                      >
                        Copy
                      </Button>
                    </div>
                  </form>
                </div>
              );
            }}
          </Formik>
        </div>
      </div>
      {iscopyLoading && <PageLoader />}
    </>
  );
};

export default CopyReport;
